import React, { useEffect, useState } from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  TextField,
  CircularProgress,
} from '@mui/material'
import { LoadingButton } from '@mui/lab'
import { useAtom } from 'jotai'
import { head, isEmpty } from 'ramda'
import { useSnackbar } from 'notistack'
import MultiViewSidebar from '../multiViewSidebar'
import DialogHeader from 'utils/dialogHeader'
import { moveToNextItemInMultiView } from 'utils/dispatchutils'
import {
  globalPostAtom,
  actionCodeAtom,
  resolveIssueAtom,
  completedRowDataAtom,
} from 'constants/atoms'
import {
  getIssueDetail,
  submitResolveIssue,
} from 'services/lotsViewServicesApi'
import { ACTION_CODES } from 'constants/actionCodes'

const CanPickUpDialog = ({ rowData, onClose }) => {
  const [actionCode, setActionCode] = useAtom(actionCodeAtom)
  const [issueData, setIssueData] = useState(null)
  const [loading, setLoading] = useState(false)
  const [selectedRowData, setSelectedRowData] = useState(head(rowData))
  const [createdPickups, setCreatedPickups] = useAtom(completedRowDataAtom)
  const [globalLoading, setGlobalLoading] = useAtom(globalPostAtom)
  const [resolveIssue, setResolveIssue] = useAtom(resolveIssueAtom)
  const { enqueueSnackbar } = useSnackbar()

  const {
    dispatch_assignment_detail_id: selectedAssignmentId = '',
    lot_number: selectedLotNumber = '',
  } = selectedRowData

  const {
    message_type_description: messageType = '',
    message_subtype_description: messageSubtype = '',
  } = issueData ? issueData : {}

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true)
      const apiData = await getIssueDetail(selectedAssignmentId)
      setIssueData(apiData)
      setLoading(false)
    }
    fetchData()
  }, [selectedRowData])

  useEffect(() => {
    if (isEmpty(createdPickups)) {
      return
    }
    if (rowData.length === createdPickups.length) {
      handleClose()
    } else if (rowData.length > createdPickups.length) {
      let curIndex = rowData.indexOf(selectedRowData)
      const nextIndex = moveToNextItemInMultiView(
        curIndex,
        createdPickups,
        rowData,
        'lot_number',
      )
      setSelectedRowData(rowData[nextIndex])
    }
  }, [createdPickups])

  const handleSubmit = async () => {
    const result = await submitResolveIssue(
      { resolution_action: 'cancel' },
      selectedAssignmentId,
    )
    if (result.success) {
      setGlobalLoading(true)
      enqueueSnackbar(`Successfully resolved issue ${selectedLotNumber}`, {
        variant: 'success',
      })
      setCreatedPickups([...createdPickups, selectedLotNumber])
    } else {
      enqueueSnackbar('Failed to resolve issue', {
        variant: 'error',
      })
    }
  }

  const handleClose = () => {
    setActionCode('')
    setResolveIssue(false)
    onClose()
  }

  return (
    <Dialog
      open={actionCode === ACTION_CODES.CAN_PICKUP}
      onClose={handleClose}
      maxWidth="md"
      fullWidth
      scroll="paper"
    >
      <DialogTitle style={{ display: 'flex' }}>
        <DialogHeader
          selectedRowData={selectedRowData}
          handleClose={handleClose}
        />
      </DialogTitle>

      <DialogContent dividers maxWidth="xs">
        <div style={{ display: 'flex', width: '100%' }}>
          {rowData.length > 1 && (
            <MultiViewSidebar
              selectedRowData={selectedRowData}
              setSelectedRowData={setSelectedRowData}
              completedRowData={createdPickups}
            />
          )}
          {loading ? (
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <CircularProgress />
            </div>
          ) : (
            <div className="col-2-3" style={{ width: '100%' }}>
              {issueData ? (
                <Grid container spacing={2}>
                  <Grid item xs={6}>
                    <TextField
                      fullWidth
                      label="Transporter Issue Details"
                      variant="standard"
                      name="issueDetails"
                      value={`${messageType} - ${messageSubtype}`}
                      InputProps={{
                        readOnly: true,
                      }}
                    />
                  </Grid>
                </Grid>
              ) : null}
            </div>
          )}
        </div>
      </DialogContent>

      <DialogActions>
        {resolveIssue && (
          <LoadingButton
            variant="contained"
            color="primary"
            onClick={() => setActionCode(ACTION_CODES.RESOLVE_ISSUE)}
            style={{ marginRight: 'auto' }}
          >
            Back
          </LoadingButton>
        )}
        <LoadingButton
          loading={globalLoading}
          variant="contained"
          color="primary"
          onClick={handleSubmit}
        >
          Save
        </LoadingButton>
      </DialogActions>
    </Dialog>
  )
}

export default CanPickUpDialog
